import React from 'react';
export const InfoboxIcon = (props: any) => {
  return (
    <svg {...props} className="svg-icon__nav">
      <svg className="svg-icon">
        <svg id="icon-h-language" viewBox="0 0 22 22">
          <title>Select Language</title>
          <path
            d="M16.500,14.500 C16.500,14.500 14.500,14.500 14.500,14.500 C14.500,14.500 8.500,18.500 8.500,18.500 C8.500,18.500 8.500,14.500 8.500,14.500 C8.500,14.500 5.500,14.500 5.500,14.500 C4.395,14.500 3.500,13.605 3.500,12.500 C3.500,12.500 3.500,5.500 3.500,5.500 C3.500,4.395 4.395,3.500 5.500,3.500 C5.500,3.500 16.500,3.500 16.500,3.500 C17.605,3.500 18.500,4.395 18.500,5.500 C18.500,5.500 18.500,12.500 18.500,12.500 C18.500,13.605 17.605,14.500 16.500,14.500 Z"
            fillRule="evenodd"
          ></path>
        </svg>
      </svg>
    </svg>
  );
};
